import {
  TransferInitiationCashType,
  TransferInitiationCashTypeDisplay,
} from '../../../api/types'
import { Select } from '@apex/component-library'
import { values } from 'lodash'
import React from 'react'
import { SelectProps } from '@apex/component-library/components/Forms/Select'

interface CashTypeSelectProps extends SelectProps {
  value: TransferInitiationCashType
  isDisabled?: boolean
  handleChange: (newValue?: TransferInitiationCashType) => void
}

const CashTypeSelect = ({
  isDisabled,
  value,
  handleChange,
  ...baseProps
}: CashTypeSelectProps) => {
  return (
    <Select
      data-testid="cash-type-select"
      value={value}
      onChange={e => handleChange(e.target.value as TransferInitiationCashType)}
      isDisabled={isDisabled}
      {...baseProps}
    >
      {values(TransferInitiationCashType).map(value => (
        <option key={value} value={value}>
          {TransferInitiationCashTypeDisplay[value]}
        </option>
      ))}
    </Select>
  )
}

export default CashTypeSelect
